import { FieldDataDefQuery } from "../../requests_cm/gecoReferentialService/types";
import * as yup from "yup";
import { Query, QuerySetpForm } from "./TimeseriesPage";
import { ContractDetailType } from "../../requests_cm/gecoContractsService/types";

export function mergeTwoArrays(array1: any, array2: any) {
	return array1.flatMap((item1: any) =>
		array2.map((item2: any) => ({ ...item1, ...item2 }))
	);
}

// Helper function to process query list
export const processQueryList = (
	fieldDefinitions: FieldDataDefQuery[] = [],
	queryList?: Record<string, Query>
): FieldDataDefQuery[] => {
	const result: FieldDataDefQuery[] = [];

	Object.values(queryList ?? {}).forEach((query: any) => {
		if (!query?.name || !query?.subquery?.length) return;

		// Filter by query name first
		const queryMatches = fieldDefinitions
			.filter((el) => el.query_name === query.name)
			// add unit and map to filtred object
			.map((el) => ({ ...el, unit: query.unit, step: query.step }));

		if (queryMatches.length === 0) return;

		// Process each subquery
		query.subquery.forEach(
			(sb: { subqueryName: string; source: string }) => {
				const subQueryMatches = queryMatches.filter(
					(e) =>
						e.sub_query === sb.subqueryName &&
						e.serviceprovider_name ===
							(sb.source ? sb.source : undefined)
				);
				result.push(...subQueryMatches);
			}
		);
	});

	return result;
};

export function getAllcombinationFromQueryform(
	values: QuerySetpForm,
	selectedContractPeriods: Partial<ContractDetailType>[],
	fielddataDefinitions: FieldDataDefQuery[] | undefined
) {
	console.debug("Processing query values:", values);

	try {
		// Validate required values
		if (!values?.activeQuery || !values?.queryList) {
			console.warn("Missing required values: activeQuery or queryList");
			return;
		}

		// Early return if no contract periods selected
		if (!selectedContractPeriods?.length) {
			console.warn(
				"No contract periods selected for combination generation"
			);
			return [];
		}

		// Process query list to filter field data
		const filteredFieldData = processQueryList(
			fielddataDefinitions,
			values.queryList
		//@ts-ignore
		).map((fd) => ({ ... fd, fielddata_id: fd.id}));

		console.debug("Filtered field data:", filteredFieldData);

		// Generate combinations if we have data
		if (filteredFieldData.length > 0) {
			const combinations = mergeTwoArrays(
				filteredFieldData,
				selectedContractPeriods
			);
			console.debug("Generated combinations:", combinations.length);
			return combinations;
		} else {
			console.warn("No field data available for combination generation");
			return [];
		}
	} catch (error) {
		console.error("Error in query filtering process:", error);
		// Optionally set empty combinations on error
		return [];
	}
}

export const contractTimeserieSchema = () => {
	return yup.object({
		dateRange: yup.object({
			startDate: yup.date().required("Date Range required field"),
			endDate: yup.date().required("Date Range required field"),
		}),
	});
};

export const removeWhitespace = (text: string): string => {
	return text.replace(/\s/g, "");
};

export const groupBy = <T>(keys: (keyof T)[]) => (array: T[]): Record<string, T[]> =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = keys.map((key) => obj[key]).join(" ");
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {} as Record<string, T[]>);
